// @dev: replace this value with the name of the widget you're building
//       (ex: m-widget-connect, m-burn-redeem-complete, etc.)
export const DATA_WIDGET_VALUE = 'm-widget-subscribe';

export const States = {
  NotConnected: 'NotConnected',
  NotAuthenticated: 'NotAuthenticated',
  NotSubscribedNoEmail: 'NotSubscribedNoEmail',
  NotSubscribedEmailLinked: 'NotSubscribedEmailLinked',
  SubscribedNotVerified: 'SubscribedNotVerified',
  Subscribed: 'Subscribed'
};
